import type { PermissionEnum } from '@Application/Security/Roles';

class CreateRole {
	constructor(
		public readonly accountId: number,
		public readonly label: string,
		public readonly description: string | null,
		public readonly permissions: readonly PermissionEnum[],
	) {
		Object.freeze(this);
	}

	// `accountId` is the route identifier: it is never echoed in the request body. `name` has no
	// field here either — the server derives it from `label`, and `forbidNonWhitelisted` would
	// reject it if sent.
	toJSON(): Record<string, unknown> {
		return {
			label: this.label,
			description: this.description,
			permissions: this.permissions,
		};
	}
}

export default CreateRole;
